<template>
  <form-group v-if="amazonAccounts.length" :columns="12" label="Conta">
    <select class="form-select" v-model="account">
      <option value="">Selecione</option>
      <option v-for="account in amazonAccounts" :key="account.partnerId" :value="account.partnerId">
        {{ account.shopName }} ({{ account.partnerId }})
      </option>
    </select>
  </form-group>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      account: '',
      amazonAccounts: []
    }),
    async mounted () {
      this.amazonAccounts = (await api.amazon.getAccounts({})).items
    },
    methods: {
      async syncOrder (data) {
        if (!this.account) {
          await api.syncOrder(data.type, data.identifier, data.code)
        }
        await api.amazon.syncOrder(data.type, data.identifier, data.code, this.account)
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SyncDialog.vue?25f48cec